import React from 'react'

function Unauthorized() {
  return (
    <div>Unauthorized Access</div>
  )
}

export default Unauthorized